import { Logger, ServiceAuthType, ServiceAuthTypeMap } from '@uploadcam/common';
import { GenerateAuthSecurityTokensInteractor } from './generate-auth-security-tokens.interactor';
import { LoginFinishInteractor } from './login-finish.interactor';
import { LoginWithPopupAdapterInteractor } from './login-with-popup-adapter.interactor';

export const CREDENTIALS_KEY = 'uploadcam_credentials';

export class LoginWithPopupInteractor {
  constructor(
    private readonly generateAuthSecurityTokens: GenerateAuthSecurityTokensInteractor,
    private readonly logger: Logger,
    private readonly loginFinish: LoginFinishInteractor,
    private readonly loginWithPopup: ServiceAuthTypeMap<LoginWithPopupAdapterInteractor>,
  ) {}

  public async execute(authType: ServiceAuthType, authTypeChanged: boolean): Promise<void> {
    this.logger.log(`Login with: ${authType}`);

    const loginWithPopupAdapter = this.loginWithPopup[authType];
    const securityTokens = await this.generateAuthSecurityTokens.execute();
    const res = await loginWithPopupAdapter.execute(
      securityTokens.state,
      securityTokens.pkceChallenge,
      authTypeChanged,
    );

    await this.loginFinish.execute(
      authType,
      res,
      securityTokens.pkceVerifier,
      securityTokens.state,
      true,
    );
  }
}
